/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc サービス関連ユーティリティ
 *
 * @author genka
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */
import Vue from 'vue'
import axios from 'axios'
import DialogUtil from '@/utils/DialogUtil'

export default new class {
  /**
   * サービスをリクエストします。
   * @param  {String}  service サービス
   * @param  {Object}  param パラメータ
   * @param  {Object}  serviceHandler start、end、success、error、requestError、serviceError、clientError
   * @param  {String}  responseType
   * @param  {String}  requestMethod
   */
  async request(service, param, serviceHandler, responseType, requestMethod) {
    if (this.service == null) {
      this._initService()
    }
    if (serviceHandler != null && serviceHandler.start != null) {
      const continuance = await serviceHandler.start()
      if (continuance === false) {
        if (serviceHandler != null && serviceHandler.end != null) {
          serviceHandler.end(true)
        }
        return
      }
    }
    let isError = false
    let response = null
    try {
      let requestParam = {
        method: requestMethod || 'POST',
        url: service,
        responseType: responseType || 'json'
      }
      if (requestMethod !== 'GET') {
        requestParam['headers'] = {
          Accept:
            'application/json',
            'Content-Type': 'application/json'
        }
        requestParam['dataType'] = 'json'
        requestParam['data'] = param || {}
      } else {
          requestParam['headers'] = {
            Accept: '*/*'
          }
      }
      response = await this.service.request(requestParam)
      if (serviceHandler != null && serviceHandler.success != null) {
        serviceHandler.success(response.data)
      }
    } catch (error) {
      isError = true
      let errorCode = null
      if (error.request != null) {
        if (error.request.status === 0 || (error.request.status >= 400 && error.request.status <= 499)) {
          errorCode = 'E0000'
          if (serviceHandler != null && serviceHandler.requestError != null) {
            serviceHandler.requestError(error)
          }
        } else {
          errorCode = 'E0001'
          if (serviceHandler != null && serviceHandler.serviceError != null) {
            serviceHandler.serviceError(error)
          }
        }
      } else {
        errorCode = 'E0004'
        if (serviceHandler != null && serviceHandler.clientError != null) {
          serviceHandler.clientError(error)
        }
      }
      if (serviceHandler != null && serviceHandler.error != null) {
        serviceHandler.error(errorCode, error)
      }
    } finally {
      if (serviceHandler != null && serviceHandler.end != null) {
        serviceHandler.end(isError)
      }
    }
  }

  /**
   * ダウンロードします。
   * @param  {String}  downloadService
   * @param  {String}  fileName
   * @param  {function}  successFunction
   */
  async download(downloadService, fileName, successFunction) {
    this.request(downloadService, null, {
      success: blob => {
        if (window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, fileName)
        } else {
          let objectURL = window.URL.createObjectURL(blob)
          let link = document.createElement('a')
          document.body.appendChild(link)
          link.href = objectURL
          link.download = fileName
          link.click()
          document.body.removeChild(link)
          if (typeof successFunction === 'function') {
              successFunction()
          }
        }
      },
      end: isError => {
        if (isError) {
          DialogUtil.showInfoDialog(Vue.prototype.$t('ダウンロードに失敗しました。'))
        }
      }
    }, 'blob', 'GET')
  }

  /**
   * サービスを初期化します。
   */
  _initService() {
    let service = axios.create({
      baseURL: Vue.prototype.$config.serviceServer
    })
    service.interceptors.response.use(this._handleSuccess, this._handleError)
    this.service = service
  }
  /**
   * サービス成功処理
   * @param  {Object} response レスポンス
   */
  _handleSuccess(response) {
    return response
  }
  /**
   * サービスエラー処理
   * @param  {Error} response エラー
   */
  _handleError = (error) => {
    return Promise.reject(error)
  }
}()



// WEBPACK FOOTER //
// ./src/utils/ServiceUtil.js